import axios from "axios";
import { showGlobalSnackbar } from "../providers/SnackbarProvider";
import { ErrorModel } from "./models/ErrorModel";

const API_URL = `${(window as any).app.env.API_URL}/api`;

const axiosClient = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

const abortControllers = new Map<string, AbortController>();

axiosClient.interceptors.request.use((config) => {
  const requestKey = config?.data?.requestKey || `${config.method}:${config.url}`;

  // If there's a pending request with the same key, abort it
  const existingController = abortControllers.get(requestKey);
  if (existingController) {
    existingController.abort(); // cancel previous request
  }

  const controller = new AbortController();
  config.signal = controller.signal;

  abortControllers.set(requestKey, controller);

  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    const requestKey = `${response.config.method}:${response.config.url}`;
    abortControllers.delete(requestKey);
    return response;
  },
  (error) => {
    if (error.code !== "ERR_CANCELED") {
      const errorMessage = new ErrorModel(
        ErrorModel.Severity.FAIL,
        error,
        error?.response?.config?.url
      );
      showGlobalSnackbar(errorMessage.message, "error");
    }

    const requestKey = `${error.config?.method}:${error.config?.url}`;
    abortControllers.delete(requestKey);

    return Promise.reject(error);
  }
);

export default axiosClient;
